import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-restart-dialog',
  templateUrl: './restart-dialog.component.html',
  styleUrls: ['./restart-dialog.component.scss']
})
export class RestartDialogComponent implements OnInit {

  constructor( public activeModal: NgbActiveModal,) { }

  ngOnInit() {
   
  }
}



// WEBPACK FOOTER //
// ./src/app/restart-dialog/restart-dialog.component.ts